import React, { useState } from 'react';
import { Column } from 'rbx';
import { useStoreState } from 'easy-peasy';
// import format from 'date-fns/format';
import moment from 'moment';
import { toast } from 'react-toastify';

import Layout from '../../../components/global/Layout';
import Header from './Header';
import Search from './Search';
import { Tabs, CheckBox } from '../../../components/elements';
import {
  downloadCSVFile,
  transformTransactionsOrders,
  fetchTransactionsOrders,
  transformTransactionsOrdersCSV,
  reinitSet,
  fetchTransactionsOrders2,
} from './helpers';
import TransactionsOrdersTable from './TransactionsOrdersTable';
import UserSuggestions from '../../../components/global/UserSuggestions';
// import Toggle from '../../MenuManagement/Menu/Designer/Toggle';

const transformStartDate = startDate => {
  const originalTimestamp = moment.utc(startDate);
  const convertedTimestamp = originalTimestamp.set({
    hour: 11,
    minute: 59,
    second: 0,
    millisecond: 0,
  });
  return convertedTimestamp.toISOString();
};

const SalesRepOrderTransactions = () => {
  const { userId } = useStoreState(state => state.auth);

  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalSize, setTotalSize] = useState(0);

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [loading, setLoading] = useState(false);

  const [filterBy, setFilterBy] = useState({
    value: 'FILTER BY MONTH',
    label: 'FILTER BY MONTH',
  });

  const [placeName, setPlaceName] = useState({ value: '' });

  const [cityFilter, setCityFilter] = useState('');

  console.log('cityFilter', cityFilter);

  const [transactionsOrdersData, setTransactionsOrdersData] = useState(null);

  const [excludeTestPlace, setExcludeTestPlace] = React.useState(false);
  const [isCashExclude, setIsCashExclude] = React.useState(false);

  const [salesRep, setSalesRep] = React.useState({});

  const [downloadCsv, setDownloadCsv] = React.useState(false);

  const onDownloadCsv = async () => {
    const orderReferences = new Set();

    setDownloadCsv(true);

    function escapeCSVValue(value) {
      if (value === null || value === undefined) return '';

      if (typeof value === 'boolean') return value ? 'true' : 'false';

      const stringValue = String(value);

      if (
        stringValue.includes(',') ||
        stringValue.includes('"') ||
        stringValue.includes('\n')
      ) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }

      return stringValue;
    }

    function generateArray(n) {
      return Array.from(Array(n).keys());
    }

    try {
      const firstPageResponse = await fetchTransactionsOrders2({
        userId,
        placeId: placeName.value,
        startDate: transformStartDate(startDate),
        endDate,
        log: false,
        from: 0,
        excludeTestPlace,
        isCashExclude,
        salesMemberId: salesRep?.user_id || null,
      });

      if (!firstPageResponse) {
        throw new Error('No response from the api!');
      }

      const totals = firstPageResponse.total_pages || 1;

      let allMenuItems = [...transformTransactionsOrdersCSV(firstPageResponse)];

      if (totals > 1) {
        const pageIndexes = generateArray(totals).slice(1);
        const remainingPagesResponses = await Promise.all(
          pageIndexes.map(pageIndex =>
            fetchTransactionsOrders2({
              userId,
              placeId: placeName.value,
              startDate: transformStartDate(startDate),
              endDate,
              log: false,
              from: pageIndex * 50,
              excludeTestPlace,
              isCashExclude,
              salesMemberId: salesRep?.user_id || null,
            }),
          ),
        );

        const remainingItems = remainingPagesResponses.flatMap(response =>
          transformTransactionsOrdersCSV(response),
        );

        allMenuItems = [...allMenuItems, ...remainingItems].filter(item => {
          if (orderReferences.has(item.orderNumber)) {
            return false;
          }

          orderReferences.add(item.orderNumber);
          return true;
        });
      }

      if (allMenuItems.length === 0) {
        throw new Error('No menu audit data available');
      }
      const headers = Object.keys(allMenuItems[0]);
      const headerRow = headers.map(escapeCSVValue).join(',');

      const dataRows = allMenuItems.map(item =>
        headers.map(header => escapeCSVValue(item[header])).join(','),
      );

      const csvContent = [headerRow, ...dataRows].join('\n');

      downloadCSVFile(
        csvContent,
        `sales-rep-report-${new Date().toISOString()}.csv`,
      );
    } catch (error) {
      toast.error(
        `Failed to download CSV: ${error.message || 'Unknown error'}`,
      );
    } finally {
      setDownloadCsv(false);
    }
  };
  const time = `${startDate}${endDate}`;

  React.useEffect(() => {
    let ignore = false;
    const fetchTab3Data = async () => {
      try {
        setLoading(true);
        const tnstOrders = await fetchTransactionsOrders({
          userId,
          placeId: placeName.value,
          startDate: transformStartDate(startDate),
          endDate,
          log: false,
          from: currentPage * 50,
          excludeTestPlace,
          isCashExclude,
          salesMemberId: salesRep?.user_id || null,
          city: cityFilter,
        });
        setTotalPages(tnstOrders.total_pages);
        setTotalSize(tnstOrders.total_size);
        if (!ignore && tnstOrders && currentPage === 0) {
          setTransactionsOrdersData(transformTransactionsOrders(tnstOrders));
        } else if (!ignore && tnstOrders) {
          setTransactionsOrdersData([
            ...transactionsOrdersData,
            ...transformTransactionsOrders(tnstOrders),
          ]);
        }
        setLoading(false);
      } catch {
        setLoading(false);
      }
    };

    if (startDate && endDate) {
      fetchTab3Data();
    }

    return () => {
      ignore = true;
    };
  }, [
    placeName,
    time,
    cityFilter,
    currentPage,
    excludeTestPlace,
    isCashExclude,
    salesRep,
  ]);

  const loadMoreDataFunc = () => {
    if (totalPages <= currentPage + 1) {
      // pass
    } else {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <Layout>
      <Header />
      <Column.Group
        style={{ padding: '1rem 1rem 0 1rem' }}
        vcentered
        multiline
        gapSize={8}
      >
        <Column size={3}>
          <CheckBox
            label="Exclude Test Restaurants"
            value={excludeTestPlace}
            onChange={value => {
              reinitSet();
              setTransactionsOrdersData([]);
              setCurrentPage(0);
              setExcludeTestPlace(value);
            }}
          />
        </Column>
        <Column size={3}>
          <CheckBox
            label="Exclude Cash Orders"
            name="event_business"
            value={isCashExclude}
            onChange={value => {
              reinitSet();
              setTransactionsOrdersData([]);
              setCurrentPage(0);
              setIsCashExclude(value);
            }}
          />
        </Column>
        <Column size={3}>
          <UserSuggestions
            placeholder="Search Sales Rep"
            initialValue=""
            label="Sales Rep"
            onSelect={data => {
              reinitSet();
              setTransactionsOrdersData([]);
              setCurrentPage(0);
              setSalesRep(data);
            }}
            onHandleClear={() => {
              reinitSet();
              setTransactionsOrdersData([]);
              setCurrentPage(0);
              setSalesRep({});
            }}
          />
        </Column>
      </Column.Group>
      <Search
        placeName={placeName.value}
        filterBy={filterBy}
        setFilterBy={setFilterBy}
        enablePlaceFilter={false}
        setEndDate={e => {
          reinitSet();
          setTransactionsOrdersData([]);
          setCurrentPage(0);
          setEndDate(e);
        }}
        setStartDate={e => {
          reinitSet();
          setTransactionsOrdersData([]);
          setCurrentPage(0);
          setStartDate(e);
        }}
        setPlaceName={e => {
          reinitSet();
          setTransactionsOrdersData([]);
          setCurrentPage(0);
          setPlaceName({ value: e });
        }}
        setCityFilter={e => {
          reinitSet();
          setCurrentPage(0);
          setTransactionsOrdersData([]);
          setCityFilter(e);
        }}
      />

      <>
        <Tabs className="tabs is-medium is-fullwidth">
          <div className="p-4">
            <button
              style={{ margin: '5px' }}
              className={`${downloadCsv &&
                'is-loading'} button is-primary is-outlined`}
              onClick={async () => {
                await onDownloadCsv();
              }}
            >
              Download CSV
            </button>
          </div>
        </Tabs>
        {!!totalSize && (
          <div className="level-left p-4">
            <div className="level-item">
              <p className="subtitle is-4">
                <strong>{totalSize} row(s)</strong>
              </p>
            </div>
          </div>
        )}
        <TransactionsOrdersTable
          loading={loading}
          transactionsOrdersData={transactionsOrdersData}
          onClick={() => {}}
          canLoadMoreData={false}
          loadMoreData={loadMoreDataFunc}
        />
      </>
    </Layout>
  );
};

export default SalesRepOrderTransactions;
